export const RESULT_STATUS = Object.freeze({
  FAILED: { title: 'Failed', color: 'error' },
  IN_PROGRESS: { title: 'In progress', color: 'info' },
  SUCCESS: { title: 'Ready', color: 'success' },
  PROCESSED: { title: 'Ready', color: 'success' },
  UNKNOWN: { title: 'Unknown', color: 'info' }
})
export const TEST_CASE_VALIDATION_SUCCESS = 'PROCESSED'

export const SHOW_NEW_VERSION_PROVIDER = 'showNewVersion'

export const SHOW_SIMILAR_RESULTS_PROVIDER = 'showSimilarResultsProvider'

export const BOM_VALIDATION_RESULT_TYPES = Object.freeze({
  COMPONENT_VARIANT: { key: 'componentVariant', label: 'Component Variants' },
  SOLUTION_ELEMENT: { key: 'solutionElement', label: 'Solution Elements' },
  TRANSFORMATION: { key: 'transformation', label: 'Transformation' }
})

export const BOM_VALIDATION_ERROR_TYPES = Object.freeze({
  AMBIGUOUS: { key: 'ambiguousElements', label: 'Ambiguous' },
  INCOMPLETE: { key: 'incompleteElements', label: 'Incomplete' },
  UNUSED: { key: 'unusedElements', label: 'Unused' }
})

export const BOM_VALIDATION_ERROR_TYPES_METRICS = Object.freeze({
  ambiguousElements: 'AMBIGUOUS',
  incompleteElements: 'INCOMPLETE'
})

export const BOM_VALIDATION_ERROR_TYPES_MESSAGE = Object.freeze({
  INCOMPLETE: {
    key: 'warn',
    label: 'There may be more incomplete configurations than displayed. CORE has reached its computing limit.'
  }
})

export const BOM_VALIDATION_TAR_FILTER_WARNING = Object.freeze({
  key: 'info',
  label: 'TAR filter is displaying only related elements from yellow and green worlds.',
  btnText: 'Display all elements'
})

export const BOM_VALIDATION_PRE_CONDITION_MESSAGE = Object.freeze({
  key: 'info',
  label: 'The result displayed is considering a precondition entered.'
})

export const BOM_VALIDATION_IN_PROGRESS = 'IN_PROGRESS'
export const BOM_VALIDATION_FAILED = 'FAILED'
export const BOM_VALIDATION_SUCCESS = 'SUCCESS'

export const CHOICE_RULE_WINDCHILL_LINK = process.env.VUE_APP_CHOICE_RULE_WINDCHILL_LINK
export const BOM_SHOW_AMBIGUOUS_LINK = process.env.VUE_APP_BOM_SHOW_AMBIGUOUS_LINK

export const VALIDATIONS_FILTERS = Object.freeze({
  NONE: { key: '', value: '' },
  USER: { key: 'creator', value: 'creator' },
  DATE: { key: 'date', value: 'date' }
})

export const BOM_VALIDATION_FILTER = Object.freeze({
  NONE: { key: '', value: '' },
  USER: { key: 'creator', value: '' },
  DATE: { key: 'date', value: '' }
})

export const TEST_CASES_VALIDATION_TYPES = Object.freeze({
  PRODUCT_MODEL: { key: 'PRODUCT_MODEL', label: 'Product Model', description: 'Select Product Model' },
  USER_EXPORT: { key: 'USER_EXPORT', label: 'On Demand Exports', description: 'Select a recent export' }
})

export const TEST_CASES_VALIDATION_FORM = Object.freeze({ productModel: {}, planningPeriod: '' })

export const TEST_CASES_FILTER = Object.freeze({
  DISPLAY_ALL: { key: 'DISPLAY_ALL', label: 'Display all', value: false },
  PINNED: { key: 'PINNED', label: 'Pinned cases', value: true }
})

export const VALIDATION_COMPARISON_RESULTS_TABS = Object.freeze({
  OVERVIEW: { label: 'Overview', key: 'OVERVIEW' },
  ONLY_DIFFERENCES: { label: 'Only differences', key: 'ONLY_DIFFERENCES' }
})
